






























import { Component, Vue, Prop } from 'vue-property-decorator';
import fubang from '../../../assets/image/fubang.png';
import fenxiang from '../../../assets/image/fenxiang.png';

// mixins
import MyHomeMixins from '../MixinsFunc/MyHomeMixins'; 
// 声明组件*****************
@Component({
    mixins: [MyHomeMixins]
})
export default class GroupMessage extends Vue {
  // 属性*****************
  private fubang: string = fubang;
  private fenxiang: string = fenxiang;
  private zhezhaoShow: boolean = false;
    
    // props
    @Prop({ default:()=>false }, Object) 
    private groupShow!: boolean
    async mounted () {
        this['invitation']();
        // 如果 有群组 就请求群列表
        if(this.$store.state.user_info.info_user_wechat.wechat_group_id >=0 ){
            await this['getGroupInfo']();
            await this['getGroupMembers']();
            this.$emit("update:groupShow", true);
        }
        
    };
    // 方法*****************
  
}
